export const EL_TG_LINK_BASE = 'https://t.me'
export const EL_TIGER_AI_HELP = 'https://t.me/tiger_trade_ai_help_bot'
export const EL_TIGER_TRADE_BOT = 'https://t.me/Tiger_Trade_Bot'
